// extracted by mini-css-extract-plugin
module.exports = {"logo":"NiraLogo_logo__1jPgx"};